type ParsedPhoneNumber = {
    isValid: () => boolean;
    countryCallingCode: string;
    nationalNumber: string;
};

type LibPhonenumber = {
    parsePhoneNumber: (value: string, iso2: string) => ParsedPhoneNumber | undefined;
};

type WindowWithLibphone = Window & { libphonenumber?: LibPhonenumber };

export interface PhoneNumberSuggestion {
    isValid: boolean;
    suggestion: string | null;
}

const EMPTY_RESULT: PhoneNumberSuggestion = { isValid: false, suggestion: null };

// Parses `rawNumber` for `iso2` and returns a suggested correction when the entered value is a valid number
// typed in a domestic format that differs from its canonical international form.
export const getPhoneNumberSuggestion = (rawNumber: string, iso2: string): PhoneNumberSuggestion => {
    if (typeof window === 'undefined') {
        return EMPTY_RESULT;
    }
    const lib = (window as WindowWithLibphone).libphonenumber;
    if (!lib || !rawNumber || !iso2) {
        return EMPTY_RESULT;
    }
    try {
        const parsed = lib.parsePhoneNumber(`+${rawNumber}`, iso2.toUpperCase());
        if (!parsed?.isValid?.()) {
            return EMPTY_RESULT;
        }
        const canonical = `${parsed.countryCallingCode}${parsed.nationalNumber}`;
        return { isValid: true, suggestion: canonical !== rawNumber ? canonical : null };
    } catch {
        return EMPTY_RESULT;
    }
};
